module.exports = {
  title: "LesPark- 全球女性直播交友官网 最in闺蜜情感助手",
  description: "LesPark是一款为全球女性提供交友渠道的pc直播和移动社交软件，是女性专属交友泛娱乐平台。在这里，你可以通过网页开启直播，与粉丝好友零距离实时互动；能够依据定位寻找附近她或参加各种活动，与附近人群建立良好、健康的社交关系。",
  header: {
    nav1: "热门直播",
    nav2: "充值",
    nav3: "主播中心",
    nav3_1: "主播管理后台",
    nav3_2: "开始PC直播",
    nav3_3: "成为签约主播",
    nav3_4: "PC直播指南",
    nav3_5: "PC开播",
    nav3_6: "爱豆提现",
    nav4: "联系我们",
    nav5: "关于我们",
    nav6: "登录/注册",
    nav7: "公司简介",
    me1: "在线充值",
    me2: "退出",
    live: "直播",
    topic: "话题",
    baihuaTitle: "百花计划",
    baihuaAward: "千万补贴",
    ContactUs: "联系客服",
    myHome: "我的首页",
    jihua:"悸花乐读",
  },
  login: {
    nav1: "登录",
    nav2: "注册",
    nav3_1: "快速登录",
    nav3_2: "直接登录",
    nav4: "使用第三方直接登录",
    nav5: "扫描二维码",
    nav6: "下载并注册LesPark",
    nav7: "或",
    nav8: "登录",
    input1: "请输入手机号",
    input2: "请输入密码",
    input3: "中国",
    input4: "美国",
    input5: "台湾",
    input6: "香港",
    input7: "澳门",
    input8: "泰国",
    input9: "马来西亚",
    input10: "新加坡",
    input11: "日本",
    input12: "韩国",
    input13: "澳大利亚",
    input14: "英国",
    input15: "菲律宾",
    input16: "越南"
  },
  home: {
    download: "扫码下载",
    download1: "苹果下载",
    download2: "安卓下载",
    download3: "谷歌下载",
    liveTitle1: "我的关注",
    liveTitle1_1: "暂时没有您关注的主播正在直播,去看看热门直播吧",
    liveTitle2: "热门直播",
    liveTitle3: "热门话题",
    liveTitle3_1: "暂时没有推荐话题",
    appProfile: "APP简介",
    more: "查看全部"
  },
  swiper: {
    0: {
      h1Content: "百花计划",
      h2Content: "拍短视频，享千万补贴"
    },
    1: {
      h1Content: "实时直播",
      h2Content: "高颜值主播和你亲密互动"
    },
    2: {
      h1Content: "多人视频",
      h2Content: "视频连麦 还有红娘牵线"
    },
    3: {
      h1Content: "附近的人",
      h2Content: "发现你身边的同好圈"
    },
    4: {
      h1Content: "情侣公园",
      h2Content: "记录相爱点滴"
    },
    5: {
      h1Content: "即时语聊",
      h2Content: "你的声音 甜过初恋"
    },
    6: {
      h1Content: "快速配对",
      h2Content: "交友脱单 心动匹配"
    }
  },
  live: {
    nav1: "关注",
    nav2: "我的关注",
    nav3: "热门直播",
    nav4: "发送",
    nav5: "加载更多",
    nav6: "直播结束",
    nav7: "关注",
    nav8: "热门"
  },
  foot: {
    content1: "粤公网安备 44180202000386号 ",
    content2: " 粤ICP备18016053号",
    content3: "清远市帕克文化传媒有限公司 2016-2020 All Rights Reserved ",
    content4: " 举报邮箱：cs@lespark.us",
    content5: " 友情链接",
    content6: " 粤网文（2018）3153-1052号",
    HelpCenter: "帮助中心",
    PrivacyPolicy: "隐私政策",
    ServiceAgreement: "服务协议",
    ReportPhone: "违法与不良信息举报电话",
    ReportEmail: "违法与不良信息举报邮箱",
    CompanyProfile: "公司简介",
    JoinUs: "加入我们",
    contactUs: "联系我们",
    ServiceTel: "客服电话"
  },
  foot2: {
    content1: "桂公网安备 45050302000153号",
    content2: " 桂ICP备20003447号-1",
    content3: "北海帕克信息科技有限公司 2016-2023 All Rights Reserved",
    content6:"桂网文（2023）1925-390号",
  },
  live_star: {
    pc: "电脑直播",
    account: "LesPark账号:",
    noLogin: "未登录,",
    login: "点击登录",
    liveTitle: "直播标题:",
    liveCover: "直播封面:",
    oldLiveCover: "使用上次直播封面（头像）",
    customimg: "自定义图片",
    plugFlow: "推流地址:",
    copy: "复制",
    secret: "密钥:",
    finishLive: "结束直播",
    getLiveAdd: "获取直播地址",
    liveNote: "开播须知:",
    liveNote1: "1. 根据相关规定，开播前，请在LesPark app内完成实名认证。请您遵守",
    liveNote2: "2. 在本网页登录LesPark账号，输入标题、选择封面后，点击“开播获取地址”按钮",
    liveNote3: "3. 在OBS中配置推流地址和密钥，点击开始推流即可",
    liveNote4: "4. 直播结束时，请务必在本页面点击“结束直播”，否则直播间将处于黑屏影响观看",
    convention: "LesPark直播公约"
  },
  mobile_login: {
    title: "请先登录哦~",
    sendCode: "发送验证码",
    resendCode: "重新发送",
    btnName: "登录",
    agreeLic: "注册即视为同意",
    lic: "《LesPark使用条款》",
    sendCodeFail: "发送验证码失败",
    errPhoneFormat: "手机格式错误",
    errVerifyCodeRequired: "验证码不能为空",
    errVerifyCodeFormat: "验证码格式错误",
    success: "登录成功",
    fail: "登录失败",
    phoneRequired: "请输入手机号",
    verifyCodeRequired: "请输入验证码"
  },
  dynamic: {
    comment: "评论",
    moreComment: "查看更多评论",
    liaoXjj: "去撩小姐姐",
    faXianXjj: "发现更多好看的姐姐",
    nodata: "帖子被发布者删除了，去LesPark发现更多有趣的帖子吧"
  },
  video: {
    comment: "输入评论...",
    more: "更多精彩视频",
    nodata: "短视频被发布者删除了，去LesPark看看他的其他作品吧~",
    notSupport: "此视频暂无法播放，请稍后再试"
  },
  profile: {
    moreFriends: "发现更多有趣的小伙伴",
    years: "岁",
    userId: "ID",
    fans: "粉丝",
    girlSounds: "萝莉音",
    chat: "私聊",
    signature: "个人签名",
    fullText: "全文",
    notSupportAudio: "您的浏览器不支持 audio 元素",
    nodata: "啊哦~这名用户账号注销了，去LesPark发现更多有趣的小姐姐吧"
  },
  common: {
    follow: "关注",
    followed: "已关注",
    followFail: "关注失败",
    goAndSeed: "去看看",
    like: "点赞",
    liked: "被赞",
    unlikeFail: "取消点赞失败",
    likeFail: "点赞失败",
    likedUnit: "人点赞"
  },
  downloadTip: {
    title: "到LesPark查看更多评论吧",
    textBtn: "去LesPark",
    video: "到LesPark App查看更多有趣的视频吧~",
    profile: "到LesPark App了解小姐姐更多信息，跟小姐姐畅聊吧~",
    dynamic: "到LesPark发现更多有趣的帖子"
  },
  bottomBar: {
    video: "到LesPark发现更多有趣的短视频",
    profile: "到LesPark发现更多有趣的小姐姐",
    dynamic: "到LesPark发现更多有趣的帖子"
  },
  error: {
    userNotExist: "用户不存在",
    networkException: "网络错误",
    phoneVerifyException: "号码异常",
    paramInvalid: "参数错误",
    verifyCodeError: "验证码错误",
    unsafeEnv: "当前使用环境有风险（机审）",
    accountRegisted: "号码已注册",
    postNotFound: "贴子不存在或已删除",
    posterNotFound: "发帖人不存在",
    userNotFound: "用户不存在"
  },
  baiHuaTxt: {
    bg1Title: "https://static.lespark.cn/pc_img/images/baihua/title-cn.png",
    award: ["￥", "2", "0", "0", "0", "W"],
    bg1Tips: "短视频创作收益奖励",
    bg1Tips2: "加入“百花计划”发布原创优质视频，享创作收益",
    rule: "规则说明",
    bg2Title: "LesPark全球最大的多元女性视频平台",
    bg2Tips: ["超多", "流量", "丰厚", "收益", "等你拿"],
    bg2Img: "https://static.lespark.cn/pc_img/images/baihua/bg2Img-cn.png",
    bg2Tips2: "现金奖励",
    bg2Tips3: "*成功加入”百花计划“产生有效播放量，即可获得超高收益",
    bg3Title: "LesPark诚邀每一位创作者加入百花计划",
    bg3Tips: ["让每个", "独一无二的你", "都被看见"],
    bg3Img: "https://static.lespark.cn/pc_img/images/baihua/tequan-cn.png",
    bg3Tips2: "以上仅为部分规划，详情请查看完整",
    bg3Tips3: "加入“百花计划”前，请你仔细阅读活动规则及相关条款",
    bg3Tips4: "凡加入本计划，则视为你已阅读，理解并同意规则全部内容",
    tqSvga: "https://static.lespark.cn/pc_img/images/baihua/tequan-cn.svga",
    titleSvga: "https://static.lespark.cn/pc_img/images/baihua/title-cn.svga",
  },
  photowall: {
    title: "全球多元女性社交",
    LaunchedYears: "上线7年+",
    millionsWomen: `2000万+<br/>女性用户`,
    content1: `服务全球`,
    content2: `千万名多元女性`,
    content3: `撮合10000+<br/>对情侣`,
    content4: `1000多个<br/>交友房`
  },
  liveAll: {
    content1: "热门直播",
    content2: "全部直播"
  },
  topicAll: {
    content1: "热门话题",
    content2: "全部话题",
    join: "人参与"
  },
  headerOptions: [
    {
      value: "anchor",
      label: "主播管理",
      children: [
        {
          value: "pc",
          label: "开始PC直播"
        },
        // {
        //   value: 'backend',
        //   label: '主播管理后台',
        // },
        {
          value: "invite",
          label: "优质直播招募"
        },
        {
          value: "sign",
          label: "签约信息录入"
        }
        // {
        //   value: 'withdraw',
        //   label: '提现',
        // },
      ]
    },
    {
      value: "union",
      label: "公会",
      children: [
        {
          value: "Trade",
          label: "公会入驻"
        },
        {
          value: "management",
          label: "公会管理"
        }
      ]
    }
  ],
  lesApp: {
    content1: "LesPark - 认识超过 2000 万 多元女性",
    content2: "条评论",
    content3: "千万女性记录和分享生活的社交平台，通过直播、语音聊天轻松表达真实自我，每天产生数十万条原创新鲜视频、语音、文字、图片，分享发现真实有趣的世界，让你享受轻松交友的社交体验。",
    content4: "LesPark的使命：链接全球少数人群，让世界更宽容、更快乐",
    content5: "实时直播",
    content6: "这里有陪伴你的高颜值主播，陪你聊天、唱歌，连接真实的你和精彩的世界",
    content7: "多人视频",
    content8: "红娘在线，多人连线模式，让你孤独的寻觅变成你们姻缘的相遇",
    content9: "附近的人",
    content10: "精准的地理位置翻看附近优秀的多元女性，让你一键GET身边的她",
    content11: "视频匹配",
    content12: "一对一视频匹配聊天，真人视频，拒绝伪装，面对面零距离热聊，瞬间了解彼此",
    content13: "情侣公园",
    content14: "多元女性情侣专属空间，记录每个相爱瞬间；完成情侣清单和每日打卡任务，获得积分兑换精美礼品",
    content15: "语音派对",
    content16: "实时在线语音派对，跟众多小姐姐一起连麦聊天、唱歌、相亲约会、玩游戏，带你1秒终结孤单",
    content17: "即时语聊",
    content18: "10秒匹配远方的她，与陌生人畅所欲言，结识新朋友，讲故事，道晚安，发现好听的声音，让声音治愈你",
    content19: "快速配对",
    content20: "交友脱单，单身待解救者，根据你的喜好位置设置快速匹配兴趣相投的她",
    content21: "用户点评",
    content22: "来自29820位用户评分",
    content23: "常见问题",
    content24: "App内会有男性用户吗？",
    content25: "不会，我们有审核客服运营团队7*24小时在线严格审核，谢绝男性用户进入，一经发现将作封禁处理。",
    content26: "为什么使用LesPark？",
    content27: "LesPark 作为专属多元女性社交的应用程序，为女性创造一个安全的空间，目标是提供一个平台来建立友善关系并进行对话，而没有欺凌、偏见和社会风险。",
    content28: "LesPark收费吗？",
    content29: "LesPark是免费的社交应用，可以在 App Store 和 安卓应用商店下载",
    content30: "LesPark会不会透露我的信息？",
    content31: "LesPark不会以任何形式向第三方透露用户信息，以确保大家的隐私安全。",
    commentList: [
      {
        time: "2021-06-28",
        name: "珍惜",
        content: "在LesPark找到了现在的女朋友是我最幸运的事，一直没在软件里面发过动态，都是默默看别人，缘分就是那么其妙吧，她还是把我找到了，果然还是要主动才行哈哈，祝愿大家都找到属于自己的幸福。"
      },
      {
        time: "2021-08-01",
        name: "花开",
        content: "因为这个圈子很小，显示生活中是深柜又不能标明自己的取向去大胆的找对象，用了这个软件之后才发现自己的身边有蛮多这样的唉，还有附近的社群可以找到一个跟你一个圈子的大家庭，感觉有了属于自己的交际圈，很开心~"
      },
      {
        time: "2021-08-01",
        name: "Zhang",
        content: "软件界面挺好看的，用来用去还是这个最靠谱，喜欢动态配对功能，好好玩，好多漂亮的小姐姐，因为里面大家都是多元女性， 不必担心别人异样的眼光。良心软件，加油挺好的赞。"
      },
      {
        time: "2021-08-13",
        name: "Christian",
        content: "这里可以不用在意异样的眼光，可以无限做自己，找到自己爱的人，找到相投的人做朋友，随着软件的一步步更新，用户体验越来越好，内容也越来越丰富。~"
      },
      {
        time: "2021-09-01",
        name: "怡婷",
        content: "作为一个多元女性以前感到很寂寞没有人理解，现在有了朋友和社区真好，已经认识不少新朋友，发现大家颜值都好高呀，支持加油赞赞。"
      }
    ]
  },
  aboutUs: {
    content1: `LesPark 为清远市帕克文化传媒有限公司旗下研发的一款为全球女性提供交友渠道的移动社交软件。不论是想成为KOL，坐拥百万粉丝；还是想交朋友、分享情感、涨知识LesPark都有专为身为女性的你打造的便利平台与真实社区。`,
    content1_1: `LesPark 为北海帕克信息科技有限公司旗下研发的一款为全球女性提供交友渠道的移动社交软件。不论是想成为KOL，坐拥百万粉丝；还是想交朋友、分享情感、涨知识LesPark都有专为身为女性的你打造的便利平台与真实社区。`,
    content1_2: `LesPark 为 ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD. 旗下研发的一款为全球女性提供交友渠道的移动社交软件。不论是想成为KOL，坐拥百万粉丝；还是想交朋友、分享情感、涨知识LesPark都有专为身为女性的你打造的便利平台与真实社区。`,
    content2: `在这里，你能够通过社区、直播展示自己，与粉丝零距离实时互动；能够依据定位加入附近群组参加各种活动，与附近人群建立良好、健康的社交关系。`,
    content3: `“Live for Love——为爱而生”，一直以来都是LesPark的口号，力于打造女性群体记录和分享生活的平台。`,
    content4: `目前，LesPark已上线运营7年，拥有垂直领域用户数已突破2000万，分布全球34个国家，主播数量已超15万。`,
    content5: `企业文化`,
    content6: `使命`,
    content7: `链接全球少数人群`,
    content8: `让世界更加宽容、更快乐`,
    content9: `愿景`,
    content10: `成为少数人群最可信赖的全球化公司`,
    content11: `在不断地创新中建立少数人`,
    content12: `群普惠价值网络`,
    content13: `价值观`,
    content14: `用户第一、团队协作`,
    content15: `结果导向、追求极致`,
    content16: `积极主动、勇敢无畏`,
    content17: `加入我们`,
    content18: `我们需要产品、运营、技术等各岗位人才，期待你的加入！`,
    content19: `立即加入`,
    content20: `联系我们`,
    content21: `联系人`,
    content22: `张先生`,
    content23: `客服电话`,
    content24: `联系地址`,
    content25: `举报投诉`,
    content26: `广东清远市广清大道八十八号云山诗意花园云山诗意大厦14层办公室08号`,
    content26_1: `广西壮族自治区北海市四川路299号穗丰金湾1幢0401号`,
    content26_2: `ORIENT BASIC SCIENCE AND TECHNOLOGY PTE. LTD.`
  },
  loginHome: {
    content1: "加载更多",
    content2: "粉丝",
    content3: "获赞",
    content4: "动态"
  },
  topicItem: {
    content1: "人赞",
    content2: "查看全部",
    content3: "条评论",
    content4: "回复",
    content5: "评论...",
    content6: "发送"
  },
  baihuaRule: {
    title: "百花计划活动规则",
    ruleSet: [
      `加入短视频百花计划（以下简称“本计划”）前，请用户详细阅读活动规则及相关条款。凡申请加入百花计划，则视为用户已阅读、理解并同意活动规则全部内容。`,
      `<h3 class="h3-label">计划介绍</h3>`,
      `百花计划是由LesPark平台举办的激励短视频创作的活动。成功加入百花计划的作者，通过站内发布的<span>原创高清视频（时长≥10秒)</span>，有机会享受创作收益。`,
      `<h3 class="h3-label">计划的加入方式</h3>`,
      `1.你可通过点击计划介绍页面的“立即加入”按钮并完成相应的申请任务，即可申请加入百花计划。`,
      `2.申请加入百花计划前，需要完成以下申请任务，平台将根据活动规则对申请者的视频内容质量进行审核，审核通过后即可成功加入百花计划。`,
      `1)完成手机号绑定，以及实名认证<br/>
2)近30天内，通过LesPark App发布过大于等于5篇公开可见的、原创高清视频（清晰度≥720P）、时长≥10秒<br/>
3)近30天内，通过LesPark App发布的所有公开可见的、原创高清视频（时长≥10秒)的总播放量达到60000
`,
      `3.当你完成申请任务时，可点击按钮，提交审核。官方工作人员将根据账号发布的原创高清视频（时长≥10秒) 以及内容质量标准（详见规则：<a href="/baihuaQualityReview.html">内容质量审核</a>）等要求，来确定你是否可以加入本计划。审核结果将通过计划介绍页面和消息通知公布。`,
      `1)如果由于不符合内容质量标准等原因未审核通过，你可以根据相应的提示原因或者建议，进行调整，或者尝试再次发布至少5篇原创高清视频（时长≥10秒)，调整完成后可再次提交审核申请。
      2)平台优先鼓励自主拍摄及创作的创作者加入本计划。
      3)当前账号为注销、删除、封禁等异常状态时，无法加入百花计划。
      4)创作的视频需满足平台原创标准（详见规则：<a href="/baihuaOriginalStandards.html">原创标准</a>），不存在色情、低俗、画面不清晰、刷粉刷播放量等不良问题。不涉及未成年、广告营销、黑产教学、言论攻击、无资质讲解财经等负面导向问题。同时注意，若账号中大量都是无意义随拍或基于一定素材简易加工，创作程度较低的视频，也无法加入百花计划。
      `,
      `<h3 class="h3-label">计划收益</h3>`,
      `1.视频创作收益<br/>
        成功加入计划后，通过LesPark App发布的原创高清视频（时长≥10秒)，若播放量达到2w、通过内容质量审核、视频作品处于“收益中”状态下，该作品的收益播放量均可获得创作收益。注意：单个视频作品的收益期为发布并通过审核后的90天内，超过90天会被设置为“收益过期”；若视频作品未通过审核，则会被设置为“审核失败”；通过审核，且未超过90天周期内，则会被设置为“收益中”状态。
        2.收益查看与提现<br/>
        1)加入百花计划后获得的收益可在LesPark App——我的——侧边栏——创作者中心，查看相关收益，也可在LesPark App——我的——侧边栏——钻石钱包，进行查看。<br/>
        2)收益的提现，每天最多申请1次，可依据可提额度，选择对应档位金额与平台，提交提现申请，提现审核通过后，会进行相应打款操作。
        `,
      `<h3 class="h3-label">计划违规说明</h3>`,
      `1.LesPark官方有权对参与本活动的用户进行安全验证<br/>
如参与本活动的用户曾经存在、出现或经LesPark官方合理怀疑存在违反法律法规或LesPark平台规则、违背诚实信用原则的行为，LesPark官方有权采取包括但不限于限制注册/登录LesPark App、禁止参与本活动、撤销活动参与资格、取消或冻结获得活动收益(包括但不限于通过参与活动可能会获得的虚拟物品、现金、实物等收益)的资格、无法获取或仅可获取部分活动收益、已获取的活动收益使用/提现受到全部/部分限制、收回已发放的活动收益、封禁帐号等处置措施，同时保留追究该用户相关法律责任的权利。
违背诚实信用原则的行为包括但不限于：<br/>
1)下载非官方客户端；<br/>
2)使用高危作弊嫌疑的手机号、虚拟手机号、QQ、微信号等第三方平台帐号注册/登录LesPark App；<br/>
3)修改页面参数、篡改设备数据；<br/>
4)以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或任何非人工方式参与活动；<br/>
5)使用模拟器、插件、外挂、App分身软件等非法工具扫码、下载、安装、注册、登录LesPark客户端、参与活动、领取活动收益、提现、进行活动收益赠与；<br/>
6)通过恶意牟利手段扰乱平台秩序；<br/>
7)使用插件、外挂、群控系统或第三方工具对LesPark平台及本活动进行干扰、破坏、修改或施加其他影响；<br/>
8)与其他用户串通或利用机器等方式进行作弊、刷取活动收益等扰乱活动秩序的行为；<br/>
9)其他LesPark平台有合理理由怀疑的违背诚实信用原则的行为。<br/>
<br/>
2.用户在参加本系列活动过程中，如存在以所获得的活动奖励进行任何盈利或非法获利、以任何形式转让或转移其通过活动所获得的奖励，或LesPark官方有合理理由怀疑用户存在不正当使用活动奖励，扰乱LesPark平台秩序的，LesPark官方有权取消用户的活动参与资格、收回已发放的活动奖励(含已使用及未使用的) 同时保留追究该用户相关法律责任的权利。
<br/><br/>
3.LesPark官方特别提示您，请您务必通过LesPark官方及LesPark官方指定路径参与本系列活动，因用户参与任何非LesPark官方活动或冒用LesPark名义开展的活动，造成用户损失的，LesPark对此不承担任何法律责任。
`,
      `<h3 class="h3-label">注意事项</h3>`,
      `1.按照相关法律规定，主办方需就获奖者在本活动下所得进行代扣代缴个人所得税的，主办方有权依法代扣代缴。未经主办方事先书面许可，用户因参加本活动所取得的权利或获得的奖励均不得转让。<br/>
2.用户不得以任何不正当手段或舞弊方式参与本活动或利用本活动从事违法行为。一经发现，主办方有权采取降低活动奖励、限制提现、账号金额清零、撤消活动资格、限制登录、封禁账号、限制再次注册使用等措施，亦有权收回用户已领取的奖励、追讨已提现的金额，并保留追究该用户责任的权利。<br/>
3.主办方依法运营此次活动，如因不可抗力、情势变更、相关政策变动、政府机关指令要求、活动参与人数不足、第三方原因等非主办方原因导致本次活动调整、暂停举办、无法进行、用户参与失败的，主办方有权随时决定修改、暂停、取消或终止本活动，并无需为此承担任何法律责任。用户自身原因导致参与失败的，不利后果由用户自行承担。用户可在本页面随时查看修改后的活动规则，若用户对修改后的活动规则有异议的，请停止继续参与，若用户继续参加本活动，则视为用户同意本活动规则的修改。<br/>
4.《LesPark使用条款》、《LesPark隐私政策》同样适用于本次活动，本次活动规则及相关条款与《LesPark使用条款》、《LesPark隐私政策》相冲突的，以本次活动规则及相关条款为准。本次活动规则及相关条款未约定的内容，仍以《LesPark使用条款》、《LesPark隐私政策》为准。<br/>
5.如果你在活动中遇到任何问题，可以打开 LesPark App，通过人工客服或者联系微信官方号等渠道，进行咨询。<br/>
6.本活动与Apple Inc.无关<br/>
`
    ]
  },
  baihuaOriginalStandards: {
    title: "百花计划 原创标准说明",
    ruleSet: [
      `<div class="h3-label">原创作品定义</div>`,
      `1.实拍类：个人或团队亲自独立创作的视频，并拥有作品内所有内容的相关版权<br/>
(1)视频内容画面干净整洁，主题明确、内容完整有记忆点，账号内容风格统一；<br/>
(2)真人出镜类视频，需有明确的人设属性，出镜人与账号实名认证信息需保持一致；<br/>
(3)非真人出镜的视频，需有明确的主题定位，可根据作品的垂类、风格、账号特征、作者提供的材料等判断账号下内容属于当前账号创作；
`,
      `2.二次剪辑创作类作品<br/>
(1)在适度引用原视频素材基础上，二次创作成为一个丰富、有信息量、有自己编辑思路、有独创性的新视频作品；<br/>
(2)二次创作形式包括但不限于体现自己想法和思考的解说点评、剪辑制作、特效包装、音频处理等；
`,
      `3.以下类型不属于原创作品<br/>
(1)上传与他人相似的作品：<br/>
● 直接搬运、录屏、屏拍他人作品上传发布；<br/>
● 在未获得版权方授权或无版权的情况下，发布（或直接上传）影视剧、综艺、动漫、音乐MV、新闻、游戏体育赛事等版权内容<br/>
● 纯录屏类内容，对创作人没有参与摄像、录制、加工的作品进行录播`,
      `(2)二次创作程度不高的内容<br/>
● 内容丰富度低，如对原有素材进行简单剪辑拼接，或简单添加短暂的开场白、场景过渡串场词、背景音乐等<br/>
● 二创成本较低，仅对视频素材或文案进行简单的翻译、配音生硬刻板等；或使用他人音频作品，仅简单配上视频画面<br/>
● 解说信息单薄，没有明确的主题和个人有效信息价值观点输出，视频内的解说文案涉嫌抄袭、观点来自网络<br/>
● 引用素材低质，如引用视频和图像素材存在模糊抖动、拉伸放大/缩小、明显黑边等情况<br/>
● 引用素材和视频主题的关联性低`,
      `(3)一文多发<br/>
● 同一视频发布在自己/公司不同的账号，且均声明原创<br/>
● 在同一账号内，同一视频重复声明原创，特殊情况下可豁免，比如：第一遍发布有误但很快删除、在第一次发布视频的基础上继续完善内容且加工点丰富<br/>`,
      `(4)无法证明原创性质的作品：<br/>
● 账号发布图集作品，且无法证明原创性：账号发布低质量图片作品，如文字信息类截图、空洞无意义的随手拍、伤感句子、经典语录等图片等；账号发布明显网图作品，如明星、美女、网红介绍等
`]
  },
  baihuaQualityReview: {
    title: "百花计划 内容质量审核规则",
    ruleSet: [
      `<div class="h3-label">一、优质原创作者</div>`,
      `1.具备稳定生产能力，在LesPark持续、稳定更新作品<br/>
2.作者生产的作品领域垂直，风格统一，有个人特色<br/>
3.作者坚持生产原创作品，尊重创作、尊重版权<br/>
4.作者持续生产优质作品，带给用户良好的观看体验<br/>
`,
      `<div class="h3-label">二、优质作品</div>`,
      `1.作品观看体验好<br/>
(1)作品质量优质：<br/>
● 封面：封面视觉冲击感强，风格统一，突出重点，有助于用户在观感上形成一个系列的认知<br/>
● 标题：标题直观突出，与内容相关，无标题夸张等问题<br/>
● 画面：视频画面美观清晰、无噪点，对比度适宜；视频画面完整，无水印过多、拉升、放大裁剪导致画面不全、黑边等问题<br/>
● 声音：视频音画同步、无杂音，人物台词声音清晰、音量适宜<br/>
● 字幕：视频字幕完整可见，字幕与视频画面、视频声音同步<br/>
● 节奏：视频流畅，播放不卡顿，情节完整，有头有尾<br/>
(2)作品满足时效性、专业性、实用性、趣味性等其一特征<br/>
(3)作品思想完整，表达主旨明确清晰，作品整体观感的舒适度、愉悦性、观赏性强`,
      `2.作品创作成本高<br/>
(1)生产前期：作品有完整的构思，拍摄过程存在脚本、情节、文案设计、演员等<br/>
(2)生产后期：通过添加字幕、背景音乐等提升视频可看性，视频剪辑流畅，视频完整度高
`,
      `<div class="h3-label">三、非优质作品</div>`,
      `(1)制作简单粗糙：<br/>
● 日常生活随手拍，内容空洞/无具体实际意义/随手拍摄/无观赏价值/缺乏可看性<br/>
● 直播预告、直播录屏等内容，无再次加工且内容单薄、画面单一<br/>
● 网络图片拼凑类图集作品<br/>
(2)画面观感不适：<br/>
● 视频给人带来严重的画面冲击感，引人不适，如血腥、密集画面<br/>
(3)不良价值观:<br/>
● 视频宣传不良风气和不当行为，如拜金、卖惨、不文明用词、打架斗殴等<br/>
(4)营销推广/诱导要赞：<br/>
● 以盈利为目的的纯广告、引导用户线下交易<br/>
● 通过情感绑架求赞求关注的恶意骗流行为<br/>
(5)谣言伪科学<br/>
● 传播未经证实的虚假消息、封建迷信和违背科学规律的内容
`
    ]
  },
  mobleTxt:{
    t1:'优质主播申请',
    download:'一键下载',
    download2:'立即下载',
    more:'查看更多',
    lesAppTitle:'- 认识超过 2000 万 多元女性',
    aboutUsT1:'虽小众 不孤独',
  }
}



// WEBPACK FOOTER //
// ./static/js/zh.js